let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("62G5t")).then(() => parcelRequire('4kcS5'));